import styled from "styled-components";
import { fontNormal } from "../../_static/Typography";

// eslint-disable-next-line import/prefer-default-export
export const buildTextFn = (props) => {
  const defaultProp = {
    tag: "span",
    fontSize: -1,
    color: "inherit",
    bold: false,
    align: "inherit",
    uppercase: false,
    capitalize: false,
    ellipsis: false,
    qaLabel: "",
    lineHeight: ""
  };

  const textData = { ...defaultProp, ...props };

  const TextAtom = styled[textData.tag].attrs({
    ...(textData.qaLabel !== ""
      ? {
          "data-qa-label": textData.qaLabel
        }
      : {})
  })`
    font-family: ${fontNormal};
    font-size: ${textData.fontSize >= 0 && `${textData.fontSize}px`};
    font-weight: ${textData.bold && "bold"};
    color: ${textData.color !== "inherit" && textData.color};
    text-transform: ${(textData.uppercase && "uppercase") ||
    (textData.capitalize && "capitalize")};
    text-align: ${textData.align !== "inherit" && textData.align};
    line-height: ${textData.lineHeight || "normal"};
  `;

  return !textData.ellipsis
    ? TextAtom
    : styled(TextAtom)`
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      `;
};
